import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  reactionsContainer: {
    position: "absolute",
    bottom: "-12px",
    left: "-10px",
    display: "flex",
    flexWrap: "wrap",
    gap: "2px",
    zIndex: 1,
  },
  reactionBubble: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    position: "relative",
  },
  emoji: {
    fontSize: "20px",
    lineHeight: 1,
    filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.2))",
  },
  count: {
    fontSize: "10px",
    fontWeight: "700",
    color: "#666",
    backgroundColor: "#fff",
    borderRadius: "50%",
    minWidth: "16px",
    height: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #ddd",
    padding: "0 3px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
  },
}));

const MessageReactions = ({ reactions, isGroup }) => {
  const classes = useStyles();

  if (!reactions || reactions.length === 0) {
    return null;
  }

  // Parse reactions if it's a string
  let parsedReactions = reactions;
  if (typeof reactions === "string") {
    try {
      parsedReactions = JSON.parse(reactions);
    } catch (e) {
      console.error("Error parsing reactions:", e);
      return null;
    }
  }

  // Group reactions by emoji
  const groupedReactions = parsedReactions.reduce((acc, reaction) => {
    const emoji = reaction.emoji;
    if (!acc[emoji]) {
      acc[emoji] = {
        emoji,
        count: 0,
        users: [],
      };
    }
    acc[emoji].count += 1;
    acc[emoji].users.push(reaction.from);
    return acc;
  }, {});

  return (
    <div className={classes.reactionsContainer}>
      {Object.values(groupedReactions).map((reaction, index) => (
        <div key={index} className={classes.reactionBubble}>
          <span className={classes.emoji}>{reaction.emoji}</span>
          {isGroup && reaction.count > 1 && (
            <span className={classes.count}>{reaction.count}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default MessageReactions;
